import _ from 'underscore';
import { CWBaseModel } from 'core/models/cwBase.model';

/**
 * Model representing the workflow of an event type
 */
export class CWWkfEvtModel extends CWBaseModel {

  canViewTreatment: boolean;

  defaults(): { [key: string]: any } {
    return {
      "code": null,
      "libelle": "",
      "active": false
    }
  }

  constructor(attributes?: { [key: string]: any }, options?: { [key: string]: any }) {
    if (!options && !_.isEmpty(attributes)) {
      options = attributes;
    }
    options = options || {};
    super(attributes, options);
    this.canViewTreatment = true;
  }

  /**
   * Process to manage the response
   */
  parse(response: { [key: string]: any }): { [key: string]: any } {
    response.id = response.code;
    if (response.id === undefined) {
      const resp = response[0];

      resp.id = resp.code;
      return resp;
    }
    return response;
  }
}
